import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const NotFound = () => (
  <div className="min-h-[70vh] flex items-center justify-center pt-24" data-testid="not-found-page">
    <SEO title="Page Not Found" description="The page you are looking for could not be found." path="/404" />
    <div className="text-center px-6">
      <p className="font-display text-8xl text-[#E6CA65]/30 mb-6">404</p>
      <h1 className="font-display text-3xl sm:text-4xl font-light text-[#F4F3EF] mb-4">This address doesn't exist</h1>
      <p className="text-[#9DA3AE] font-light mb-8">But many beautiful ones do.</p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.14em] font-semibold px-8 py-4 rounded-full text-[#0B0C10] bg-gradient-to-r from-[#E6CA65] via-[#C5A880] to-[#9A7B4F]"
      >
        Return Home
      </Link>
    </div>
  </div>
);

export default NotFound;
